export const Arrow360 = () => (
  <svg
    data-icon="Arrow360"
    width="771"
    height="57"
    viewBox="0 0 771 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.18041 7.74371C0.486576 8.19636 0.29106 9.12576 0.743709 9.81959L8.12005 21.1262C8.5727 21.82 9.5021 22.0156 10.1959 21.5629C10.8898 21.1103 11.0853 20.1809 10.6326 19.487L4.07588 9.4367L14.1262 2.87995C14.82 2.4273 15.0156 1.4979 14.5629 0.804068C14.1103 0.110237 13.1809 -0.0852785 12.487 0.36737L1.18041 7.74371ZM770.248 9.83271C770.708 9.14366 770.522 8.21226 769.833 7.75236L758.604 0.257988C757.915 -0.201904 756.984 -0.0161352 756.524 0.672915C756.064 1.36197 756.25 2.29337 756.939 2.75326L766.92 9.41493L760.258 19.396C759.798 20.0851 759.984 21.0165 760.673 21.4764C761.362 21.9363 762.293 21.7505 762.753 21.0614L770.248 9.83271ZM1.69121 10.4679C293.691 71.895 461.845 71.792 769.293 10.471L768.707 7.52897C461.634 68.775 293.89 68.8713 2.30879 7.53213L1.69121 10.4679Z"
      fill="white"
    />
  </svg>
);
